module.exports = __webpack_public_path__ + "media/images/flags/TT-7191c601f1e6e96b7a775f5994e496f5.svg";